import { Pipe, PipeTransform } from '@angular/core';
import { Party } from '../models/party-manager/party';

@Pipe({
  name: 'ispTranslation'
})
export class IspTranslationPipe implements PipeTransform {

  transform(value: string, isps: Party[]): string {
    const selectedIsp = isps.find(customer => customer.namingId === value);
    return selectedIsp ? selectedIsp.name : '';
  }

}
